/* eslint-disable import/prefer-default-export */

export const notAllowedDomains = ['logout', 'login', 'global'];

export const INACTIVITY_TIMER = 15 * 60 * 1000;
